import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuServiceService } from '../../menu-service/menu-service.service';
import { Utils } from 'src/app/core/resources/utils';
import { Router } from '@angular/router';
import { Fmt } from 'src/app/core/messages/fmt';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { VehicleCargo } from 'src/app/core/interfaces/vehicle-cargo';
import { VehiclesService } from 'src/app/modules/administration/vehicles/list-vehicles.service';
import { Permission } from 'src/app/core/resources/permission';
import { CargoItemService } from 'src/app/modules/cargo/cargo-item/cargo-item.service';
import { map } from 'rxjs/operators';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { environment } from 'src/environments/environment';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CurrencyPipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { DateManager } from 'src/app/core/managers/date.manager';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { CompanyNamePipe } from 'src/app/core/pipe/companyName.pipe';
import { DateFormatPipe } from 'src/app/core/pipe/dateFormat.pipe';
import { CargoService } from 'src/app/core/services/cargo.service';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { CargoDetailService } from 'src/app/modules/cargo/cargo-detail/cargo-detail.service';
import { MToKmPipe } from 'src/app/core/pipe/mToKm.pipe';
import { ServiceResources } from '../../resources/services';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { PlanningRouteService } from 'src/app/core/services/planning-route.service';
import { GuideService } from 'src/app/core/services/guide.service';
import { GuideClientIdValidationItem } from 'src/app/core/services/guide.service';
import { CargoRouteVisualizationComponent } from '../cargo-route-visualization/cargo-route-visualization.component';
import { AdminUsersService } from 'src/app/modules/administration/admin-users/admin-users.service';
import { User } from 'src/app/core/interfaces/user';
import { VehicleMessages } from 'src/app/core/messages/vehicle-messages.enum';
import { RequestTermsDialogComponent } from 'src/app/modules/administration/request-terms-dialog/request-terms-dialog.component';
import { shouldShowRndcIntermittencyAuthorizationDialog, getRndcRequestFailureDisplayMessage } from 'src/app/modules/rndc/rndc-utils';

//TODO: Publicacion de servicio
@Component({
  selector: 'app-service-publication-form',
  templateUrl: './service-publication-form.component.html',
  styleUrls: ['./service-publication-form.component.scss'],
  providers: [CompanyNamePipe, MToKmPipe]
})

export class ServicePublicationFormComponent implements OnInit, OnDestroy {
  formSubscription: Subscription;
  permission = Permission;
  publicationZone = new FormControl('', [Validators.required]);
  publicationZones = [
    {
      value: 'private',
      name: 'Privada',
      description: 'Visible solo para los conductores directamente asociados a la compañía.'
    },
    {
      value: 'public',
      name: 'Pública',
      description: 'Visible para todos los conductores de la comunidad LoggiApp.'
    },
    {
      value: 'reserved',
      name: 'Reservada',
      description: 'Reservada para la asignación de un conductor que está confirmado que tomará el servicio.'
    }
  ]
  rate = 0;
  totalCost = 0;
  reteicaPercentage = 0;
  reteicaValue = 0;
  reteftePercentage = 0;
  retefteValue = 0;
  fopatPercentage = 0;
  fopatValue = 0;
  additionalServicesCost = 0;
  additionalServicesRate = 0;
  vehicleInsuranceDiscountCargo = 0;
  isDialog = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public paramsDialog: { cargo: Cargo },
    public dialogRef: MatDialogRef<ServicePublicationFormComponent>,
    public utils: Utils,
    public menuService: MenuServiceService,
    private router: Router,
    private authService: AuthService,
    private vehiclesService: VehiclesService,
    private cargoItemService: CargoItemService,
    private permissionRole: PermissionRole,
    private snackBarService: SnackBarService,
    private spinner: NgxSpinnerService,
    private cargoManager: CargoManager,
    private dialog: MatDialog,
    private companyNamePipe: CompanyNamePipe,
    private mToKmPipe: MToKmPipe,
    private dateFormatPipe: DateFormatPipe,
    private currencyPipe: CurrencyPipe,
    private service: CargoDetailService,
    private serviceResources: ServiceResources,
    private planningRouteService: PlanningRouteService,
    private guideService: GuideService,
    private adminUserService: AdminUsersService,
  ) { }

  async ngOnInit() {
    await this.checkDialogParams();
    this.setLocalValues();
    this.setSubscription();
  }

  private async checkDialogParams() {
    if (this.paramsDialog && this.paramsDialog.cargo) {
      this.isDialog = true;
      this.menuService.cargo = this.paramsDialog.cargo;
      this.menuService.patchForm(this.paramsDialog.cargo, false);
      await this.menuService.setCargoConsignments();
    }
  }

  private async setLocalValues() {
    this.publicationZone.setValue(this.menuService.form.get('zone').value);
    const totalCost = this.utils.getNestedValue(this.menuService.form.value, 'shippingCost.totalCost');
    if (totalCost) this.totalCost = totalCost;
    const rate = this.utils.getNestedValue(this.menuService.form.value, 'shippingCost.rate');
    if (rate) this.rate = rate;
    const reteicaPercentage = this.utils.getNestedValue(this.menuService.form.value, 'shippingCost.reteicaPercentage');
    const reteftePercentage = this.utils.getNestedValue(this.menuService.form.value, 'shippingCost.reteftePercentage');
    const fopatPercentage = this.utils.getNestedValue(this.menuService.form.value, 'shippingCost.fopatPercentage');
    this.reteicaPercentage = reteicaPercentage ? reteicaPercentage : 0;
    this.reteftePercentage = reteftePercentage ? reteftePercentage : 0;
    this.fopatPercentage = fopatPercentage ? fopatPercentage : 0;
    const reteicaValue = this.utils.getNestedValue(this.menuService.form.value, 'shippingCost.reteicaValue');
    const retefteValue = this.utils.getNestedValue(this.menuService.form.value, 'shippingCost.retefteValue');
    const fopatValue = this.utils.getNestedValue(this.menuService.form.value, 'shippingCost.fopatValue');
    this.reteicaValue = reteicaValue ? reteicaValue : 0;
    this.retefteValue = retefteValue ? retefteValue : 0;
    this.fopatValue = fopatValue ? fopatValue : 0;
    this.additionalServicesCost = this.cargoItemService.getTotalAdditionalCosts(this.menuService.form.getRawValue());
    this.additionalServicesRate = this.cargoItemService.getTotalAdditionalRate(this.menuService.form.getRawValue());
    this.vehicleInsuranceDiscountCargo = this.cargoItemService.getVehicleInsuranceDiscountCargo(this.menuService.form.getRawValue());
  }

  private setSubscription() {
    this.formSubscription = this.menuService.formObservable.subscribe(() => this.setLocalValues());
  }

  get hasPermissionsCosts(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.showCostCargo
    ) && this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.additionalCosts
    );
  }

  get hasPermissionsRate(): boolean {
    return this.hasPermissionShowRate && this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.additionalCosts
    );
  }

  get hasPermissionShowRate(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.showRateCargo
    );
  }

  get showAppUsageDiscount(): boolean {
    return !!this.authService.getCompany().appUsageDiscountEnabled;
  }

  get canSeeAndEditPublicationZone(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.editPublicationZone
    ) && this.menuService.isTransportService();
  }

  get canSeeFinancialInformationSection(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.showFinancialInformationModule
    );
  }

  get canCreateCargoFromRequest(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.createCargoFromRequest
    ) || this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.createService
    )
  }

  get canSeeVehicleAssignedInfo(): boolean {
    const licensePlate = this.menuService.form.get('licensePlate');
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.showDriverInfoModule
    ) && !!(licensePlate && licensePlate.value);
  }
  /**
   * @description Navigates to the previous step
   */
  backToPreviousStep() {
    const isRequiredConsignmentsService = this.menuService.isRequiredConsignmentsService();
    this.router.navigate([Fmt.string(isRequiredConsignmentsService
      ? this.serviceResources.serviceRequestUrls.consignmentsService
      : this.serviceResources.serviceRequestUrls.observationsService
      , this.menuService.cargo.consecutive)]);
  }

  private async updateCargo(): Promise<boolean> {
    this.menuService.form.get('zone').setValue(this.publicationZone.value);
    const { distancy, estimatedTime } = await this.menuService.getRouteGoogleData(this.menuService.cargo);
    this.menuService.form.get('distancy').setValue(distancy);
    this.menuService.form.get('estimatedTime').setValue(estimatedTime);
    try {
      await this.menuService.updateService();
      return true;
    } catch (error) {
      return false;
    }
  }

  private isFormValid(): boolean {
    if (this.utils.errorMessagesCustomized(this.publicationZone, 'zona de publicación')) return false;
    return true;
  }

  async saveAndContinue() {
    if (this.isDialog && !this.isFormValid()) return;
    const isUpdated = await this.updateCargo();
    if (!isUpdated) return this.snackBarService.openSnackBar("Ocurrió un error al actualizar el servicio", undefined, 'error');
    this.snackBarService.openSnackBar('Servicio actualizado exitosamente');
    if (isUpdated && this.isDialog) this.dialogRef.close({ state: true });
  }

  async confirmRoute(): Promise<{ continue: boolean }> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.menuService.cargo,
      type: 'confirm',
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(CargoRouteVisualizationComponent, dialogConfig);
    const result = await dialogRef.afterClosed().toPromise();
    if (!result || !result['state']) return { continue: false };
    return { continue: true };
  }

  async createCargo(overrideRiskValidation?: boolean) {
    if (!this.menuService.isValidEntireCargo().isValid)
      return this.snackBarService.openSnackBar(this.menuService.isValidEntireCargo().error, undefined, 'error');
    const licensePlate = this.menuService.cargo.licensePlate;
    if (licensePlate) {
      this.spinner.show();
      const verificationResult = await this.menuService.updateCargoVehicle(licensePlate, overrideRiskValidation);
      this.spinner.hide();
      if (!verificationResult.canProceed) {
        if (verificationResult.termsUnaccepted) {
          this.openModalRequestTerms(verificationResult.driver);
          return this.snackBarService.openSnackBar(`El conductor del vehículo ${licensePlate} no ha aceptado ${verificationResult.termsUnaccepted}`, undefined, 'alert');
        }
        if (verificationResult.missingInfo)
          return this.showDialogPendingDocuments(licensePlate, verificationResult.missingInfo);
        if (verificationResult.riskValidationBlocked) {
          const { continueAnyway } = await this.cargoManager.showRiskValidationBlockedDialog(verificationResult.error);
          if (continueAnyway) return this.createCargo(true);
          return;
        }
        return this.openModalDialogError(`Error en el vehículo asignado ${licensePlate}`, verificationResult.error);
      }
    }
    const checkTripTimes = await this.menuService.checkTripTimes(this.menuService.cargo);
    if (!checkTripTimes.valid)
      return this.snackBarService.openSnackBar(checkTripTimes.error, undefined, 'error');
    const isUpdated = await this.updateCargo();
    if (!isUpdated) return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    const confirmRoute = await this.confirmRoute();
    if (!confirmRoute.continue) return;
    let alertMessage = '';
    let isRateOrCostZero = !!(this.menuService.cargo && this.menuService.cargo.shippingCost && (this.menuService.cargo.shippingCost.rate === 0 || this.menuService.cargo.shippingCost.freightCost === 0));
    let permissionToCreateWithRateOrCostZero = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.createCargoWithRateOrCostZero);
    if (isRateOrCostZero && permissionToCreateWithRateOrCostZero) {
      alertMessage += 'Has ingresado un valor de 0 '
      alertMessage += `${this.menuService.cargo.shippingCost.rate === 0 && this.menuService.cargo.shippingCost.freightCost === 0 ? 'para la tarifa y el flete' : this.menuService.cargo.shippingCost.rate === 0 ? 'para la tarifa' : 'para el flete'}`;
      alertMessage += '. Si esto es correcto, continúa; de lo contrario, revisa el valor ingresado';
    }
    const dialogConfig = new MatDialogConfig();
    const value = this.utils.getNestedValue(this.menuService.cargo, 'cargoFeature.cargoMeasure.amount');
    dialogConfig.data = {
      title: `¿Estás seguro que deseas crear el servicio ${this.menuService.cargo.consecutive}?`,
      messageList: [
        `Operación: ${this.companyNamePipe.transform(this.menuService.cargo.idCompany)}`,
        `Origen: ${this.menuService.cargo.cargoFeature.uploadDownload.origin.name}`,
        `Fecha de origen: ${this.dateFormatPipe.transform(this.menuService.cargo.dateLoad, "only-date")}`,
        `Destino: ${this.menuService.cargo.cargoFeature.uploadDownload.destination[this.menuService.cargo.cargoFeature.uploadDownload.destination.length - 1].name}`,
        `Fecha de destino: ${this.dateFormatPipe.transform(this.menuService.cargo.cargoFeature.uploadDownload.destination[this.menuService.cargo.cargoFeature.uploadDownload.destination.length - 1].downloadDate, "only-date")}`,
        `Distancia estimada: ${this.mToKmPipe.transform(this.menuService.cargo.distancy)}`,
      ],
      showYesBtn: true,
      showNoBtn: true,
      hideBtnCancel: true,
    };
    if (this.menuService.isTransportService()) {
      dialogConfig.data.messageList.push(`¿Requiere manifiesto?: ${this.menuService.cargo.ministry ? 'Si' : 'No'}`);
      const monitoringCompany = this.utils.getNestedValue(this.menuService.cargo, 'monitoringCompany.name');
      if (monitoringCompany) dialogConfig.data.messageList.push(`Empresa de monitoreo: ${monitoringCompany}`);
      dialogConfig.data.messageList.push(`Valor declarado: ${this.utils.isDefined(value) ? this.currencyPipe.transform(value, "COP", "code") : '-'}`);
      if (alertMessage) dialogConfig.data.descriptionHTML = `
        <div class="alert alert-warning m-3 d-flex align-items-center justify-content-center" role="alert">
          <i class="fas fa-exclamation-triangle mr-2"></i><span>${alertMessage}</span>
        </div>
      `;
    }

    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    const result = await dialogRef.afterClosed().toPromise();
    if (!result || !result['state']) return;
    const isUrbanService = this.utils.isSameCity(this.menuService.cargo);
    this.spinner.show();
    this.service.requestCargo(this.menuService.cargo.id).subscribe(
      async (response) => {
        this.menuService.applyCargoFromRndcResponse(response);
        await this.menuService.setCargoConsignments();
        if (!this.menuService.isTransportService() && !isUrbanService) await this.applyPlanningRouteForEscortService();
        this.spinner.hide();
        this.snackBarService.openSnackBar(`El servicio ${this.menuService.cargo.consecutive} ha sido programado exitosamente`);
      },
      async (error) => {
        this.menuService.applyCargoFromRndcResponse(error);
        if (this.shouldShowConsignmentContingencyDialog(error)) {
          return this.handleRndcConsignmentContingency();
        }
        this.showRequestCargoError(error);
      }
    );
  }

  private async handleRndcConsignmentContingency(): Promise<boolean> {
    this.spinner.hide();
    const rndcContingencyCopy = {
      title: 'RNDC Intermitente',
      message:
        'El RNDC presenta intermitencia y no es posible generar la remesa. '
        + 'Puede continuar sin la radicación, la cual se generará automáticamente al restablecerse el servicio, '
        + 'siempre y cuando no presente errores, o esperar a que el servicio se normalice '
        + 'para poder generar la documentación con el radicado.',
      warningMessage:
        'Al continuar sin generar la remesa, el proceso queda bajo responsabilidad de la empresa de transporte.',
    };
    const confirmed = await this.openContingencyDialog(rndcContingencyCopy).toPromise();
    if (!confirmed) return true;
    try {
      this.spinner.show();
      await this.service.authorizeCargoWithoutConsignment(this.menuService.cargo.id).toPromise();
      await this.menuService.refreshCargo();
      await this.menuService.setCargoConsignments();
      this.spinner.hide();
      this.snackBarService.openSnackBar('Servicio autorizado bajo intermitencia RNDC sin remesa emitida.');
      return true;
    } catch (authorizationError) {
      this.showRequestCargoError(authorizationError);
      return true;
    }
  }

  private shouldShowConsignmentContingencyDialog(responseOrError: unknown): boolean {
    return shouldShowRndcIntermittencyAuthorizationDialog(responseOrError, this.menuService.cargo);
  }

  private openContingencyDialog(dialogCopy: {
    readonly title: string;
    readonly message: string;
    readonly warningMessage: string;
  }): Observable<boolean> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      title: dialogCopy.title,
      description: dialogCopy.message,
      descriptionHTML: `
        <div class="alert alert-warning m-3 d-flex align-items-center justify-content-center" role="alert">
          <i class="fas fa-exclamation-triangle mr-2"></i><span>${dialogCopy.warningMessage}</span>
        </div>
      `,
      iconAlert: true,
      labelButton1: 'Cancelar',
      labelButton2: 'Confirmar',
      hideBtnCancel: true,
      hideBtnConfirm: true,
      closeModal: true,
    };
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(
      map((result: { readonly state?: boolean; readonly refuse?: string } | undefined) =>
        !!(result && result.state && result.refuse === 'Confirmar')
      )
    );
  }

  private showRequestCargoError(error: unknown): void {
    this.spinner.hide();
    this.snackBarService.openSnackBar(
      this.getErrorMessage(error) || ServiceMessages.GENERAL_HTTP_ERROR,
      undefined,
      'error'
    );
    this.menuService.setCargoConsignments();
  }

  private getErrorMessage(error: unknown): string | undefined {
    const displayMessage = getRndcRequestFailureDisplayMessage(error);
    if (displayMessage) {
      return displayMessage;
    }

    const httpError = error as { error?: { message?: string } };
    const backendMessage = httpError && httpError.error && httpError.error.message;
    if (!this.utils.isEmpty(backendMessage)) {
      return backendMessage.trim();
    }

    return undefined;
  }

  ngOnDestroy() {
    if (this.formSubscription) this.formSubscription.unsubscribe();
  }

  private async applyPlanningRouteForEscortService(): Promise<void> {
    try {
      const cargo = this.menuService.cargo;
      const hasPermission = this.permissionRole.hasPermission(
        this.permission.routes.module,
        this.permission.routes.assignRouteItineraryUnrestricted
      );

      const result = await this.planningRouteService.checkPlanningRoute(cargo, hasPermission);

      if (result.success && result.message) {
        this.snackBarService.openSnackBar(result.message);
      } else if (!result.success && result.message) {
        this.snackBarService.openSnackBar(result.message, undefined, 'error');
      }
    } catch (error) {
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    }
  }

  private showDialogPendingDocuments(licensePlate: string, missingInfo: { missingDocuments: string[], unacceptedDocuments: string[], invalidReferences: string[] }) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { title: `Error en la Información obligatoria del Vehículo ${licensePlate}`, hideBtnConfirm: true };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data.descriptionHTML = '';
    if (missingInfo.missingDocuments.length) {
      let missingDocumentsMessage = '';
      missingInfo.missingDocuments.forEach(document => missingDocumentsMessage += `<li>${document}</li>`);
      dialogConfig.data.descriptionHTML += `<p>${VehicleMessages.VEHICLE_DOCUMENTATION_INCOMPLETE}</p><ol>${missingDocumentsMessage}</ol>`;
    }
    if (missingInfo.unacceptedDocuments.length) {
      let unacceptedDocumentsMessage = '';
      missingInfo.unacceptedDocuments.forEach(document => unacceptedDocumentsMessage += `<li>${document}</li>`);
      dialogConfig.data.descriptionHTML += `<p>${VehicleMessages.VEHICLE_DOCUMENTATION_UNACCEPTED}</p><ol>${unacceptedDocumentsMessage}</ol>`;
    }
    if (missingInfo.invalidReferences.length) {
      let invalidReferencesMessage = '';
      missingInfo.invalidReferences.forEach(document => invalidReferencesMessage += `<li>${document}</li>`);
      dialogConfig.data.descriptionHTML += `<p>${VehicleMessages.VEHICLE_REFERENCES_UNACCEPTED}</p><ol>${invalidReferencesMessage}</ol>`;
    }
    return this.dialog.open(DialogComponent, dialogConfig);
  }

  public openModalDialogError(title: string, description?: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
      iconError: true,
      descriptionHTML: `<p class="text-center">${description}</p>`,
      hideBtnConfirm: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  private openModalRequestTerms(driver: User) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      name: driver.information.name,
      document: driver.information.document,
      phone: driver.phone,
      user: driver
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.dialog.open(RequestTermsDialogComponent, dialogConfig);
  }
}
